module.exports = {
      apiUrl: 'https://v2202601328894424157.ultrasrv.de/api'
    };